var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inline-svg',{attrs:{"src":require('@/assets/custom-icons/' + _vm.svgFileName)}})
}
var staticRenderFns = []

export { render, staticRenderFns }